/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Expiration_3monthsInputs */

const he_notifications_expiration_3months = /** @type {(inputs: Notifications_Expiration_3monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 חודשים`)
};

const en_notifications_expiration_3months = /** @type {(inputs: Notifications_Expiration_3monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Months`)
};

/**
* | output |
* | --- |
* | "3 Months" |
*
* @param {Notifications_Expiration_3monthsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_expiration_3months = /** @type {((inputs?: Notifications_Expiration_3monthsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Expiration_3monthsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_expiration_3months(inputs)
	return en_notifications_expiration_3months(inputs)
});